var map = {
  "./overridableRegistry/oarepo_ui/mapping": "92381",
  "./overridableRegistry/oarepo_ui/mapping.js": "92381"
};



function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then((id) => (__webpack_require__(id)));
}
function __rspack_async_context_resolve(req) {
  // Here Promise.resolve().then() is used instead of new Promise() to prevent
  // uncaught exception popping up in devtools
  return Promise.resolve().then(() => {
if(!__webpack_require__.o(map, req)) {
  var e = new Error("Cannot find module '" + req + "'");
  e.code = 'MODULE_NOT_FOUND';
  throw e;
}
return map[req];
});
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 97887;
module.exports = __rspack_async_context;
